import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Outlet, Navigate, RouterProvider, createBrowserRouter } from 'react-router';

import App from './app';
import { routesSection } from './routes/sections';

// ----------------------------------------------------------------------

Sentry.init({
  dsn: 'https://66aec7ca324c06f76667baa5b8201e24@o4507485780901888.ingest.de.sentry.io/4509687690559568',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <Sentry.ErrorBoundary fallback={<ErrorFallback />} />,
    children: routesSection,
  },
]);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

// ----------------------------------------------------------------------

function ErrorFallback({ error }: { error?: Error }) {
  const errorMessage = error?.message || 'Unknown error occurred';
  const errorStack = error?.stack || '';

  // 에러 정보를 세션스토리지에 저장 (URL이 너무 길어지는 것을 방지)
  if (error) {
    sessionStorage.setItem(
      'errorInfo',
      JSON.stringify({
        message: errorMessage,
        stack: errorStack,
        name: error.name,
        timestamp: new Date().toISOString(),
      })
    );
  }

  return <Navigate to="/error/404" replace />;
}
